@if (articlesFeatured) {
  <div class="container spacer-list">
    <div class="layout-column spacer-hr-16">
      <div class="layout-row">
        <gh-snippet-hero [articles]="articlesFeatured" class="full-w"></gh-snippet-hero>
      </div>
      <div class="articles-list space-between">
        <div class="layout-column">
          @for (item of articlesOdd; track item) {
            <gh-snippet-mobile class="large" [article]="item"></gh-snippet-mobile>
          }
        </div>
        <div class="layout-column align-end">
          @for (item of articlesEven; track item) {
            <gh-snippet-mobile [article]="item" [size]="h3"></gh-snippet-mobile>
          }
        </div>
      </div>
      <gh-pagination [pager]="pager" type="home" [currentPage]="currentPage" [pageIndex]="pageIndex" [pagePreviewSize]="pagePreviewSize"
      [pagePreviewList]="pagePreviewList"></gh-pagination>
    </div>
  </div>
}

@if (showSocialCampaign) {
  <div class="social-campaign bgr-red spacer-bottom-64">
    <div class="flex align-center">
      <img [src]="cdnPath + '/develop/gohenry-campaign-order-free-card-v1.jpg'" width="673" height="410" alt="gohenry campaign order free card">
    </div>
    <div class="layout-column align-center txt-white spacer-40">
      <h2 class="spacer-bottom-32">Social campaign Lorem ipsum dolor sit amet, consectetur adipiscisi.</h2>
      <a class="btn btn-white txt-red cta-btn" [href]="signup">Order a FREE card today</a>
      <p class="small text-center spacer-top-16">One month free trial. Order your free card in minutes. Cancel at any time.</p>
    </div>
  </div>
}

@if (currentPage === 1) {
  <div>
    @for (item of categories; track item) {
      <div>
        <gh-category-section [category]="item"></gh-category-section>
      </div>
    }
  </div>
}

<div class="bgr-light-grey category-section">
  <gh-category-menu-section></gh-category-menu-section>
</div>

<div class="bgr-aqua newsletter-section">
  <div class="spacer-vr-48">
    <gh-newsletter-form></gh-newsletter-form>
  </div>
</div>
